import { all, call, fork, put, take, select } from 'redux-saga/effects';
import { params, postJSON } from '../../util';


export function* watchSignupApi() {
    while (true) {
        const action = yield take('user:signup-api');
        const api = yield select((state) => state.api);
        const extra_params = yield select((state) => {
            const promo = state.cookie && state.cookie.promo || {};
            const external = promo.signup_promo_external && promo.signup_promo_external.value;
            const internal = promo.signup_promo_internal && promo.signup_promo_internal.value;
            return {
                signup_promo_external: external || null,
                signup_promo_internal: internal || null,
                signup_property_id: state.property_id,
            };
        });

        try {
            yield call(
                postJSON,
                api.host + '/member/signup?' + params(api.params),
                {...action.payload, ...extra_params}
            );

            yield put({ type: 'user:refresh' });

            if (action.payload.privacy_policy) {
                yield all([
                    put({ type: 'cookie:set', payload: { name: 'PRIVACY_POLICY_CONSENT', value: 1 } }),
                    put({ type: 'cookie:set', payload: { name: 'POLICY_CONSENT_SHOWN', value: 1 } }),
                    put({ type: 'member:privacy-policy-consent' }),
                ]);
            }
        } catch (e) {
            let response = null;
            try {
                response = JSON.parse(e.responseText);
            } catch (e2) {
                response = {detail: {message: e.responseText}};
            }
            yield put({
                type: 'user:update',
                payload: get_error_messages(response.detail),
            });
        }
    }
}

function get_error_messages(detail) {
    let user_error_updates = {};
    if (detail.fields) {
        if (detail.fields.forum_name) {
            user_error_updates.forumNameError = detail.fields.forum_name[0];
        }
        if (detail.fields.birth_date) {
            user_error_updates.birthDateError = 'Please check your Birth Date.';
        }
        if (detail.fields.email) {
            user_error_updates.emailError = detail.fields.email[0];
        }
        if (detail.fields.password) {
            user_error_updates.passwordError = detail.fields.password[0];
        }
        user_error_updates.generalError = 'Please fill out required fields.';
    } else {
        user_error_updates.generalError = detail.message;
    }
    return user_error_updates;
}

export function* root() {
    yield fork(watchSignupApi);
}



// WEBPACK FOOTER //
// ./app/sagas/user/signup-api.js